import { useCallback } from 'react';
import { useAnalytics } from '@/shared/features/analytics/presentation/hooks/useAnalytics';
import {
  NAVIGATION_BAR_CLICKED,
  navigationBarClickedEventProperties,
  type NavigationBarClickContext,
} from '@/shared/features/analytics/utils/navigationBarClicked';

export function useTrackNavigationBarClick() {
  const { analytics, isInitialized } = useAnalytics();

  return useCallback(
    (ctx: NavigationBarClickContext) => {
      if (!analytics || !isInitialized) return;
      const props = navigationBarClickedEventProperties(ctx);
      if (!props['Button Name']) return;
      try {
        analytics.trackEvent(NAVIGATION_BAR_CLICKED, props);
      } catch (err) {
        console.error('Error tracking Navigation Bar Clicked:', err);
      }
    },
    [analytics, isInitialized],
  );
}
